import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faClock, faEdit, faFilter, faMicroscope, faPlus, faSave, faSearchPlus, faSquareXmark, faStar, faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { Box, Drawer } from "@mui/material"
import debounce from 'lodash.debounce';
import ConfirmBox from "../../components/ConfirmBox"


const RowsField = {
    id: "id",
    itemCode: "itemCode",
    itemName: "itemName",
    pcs: "pcs",
    weight: "weight",
    rate: "rate",
    amount: "amount"
}
export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    variant,
    color,
    handleInputChange,
    handleKeyDown,
    hanldeBlur,
    gridType
}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {

        setLocalValue(row[input_id] ?? "");
    }, [row[input_id]]);

    const onBlur = (e) => {
        if (localValue !== row[input_id]) {
            handleInputChange(row.id, { target: { value: localValue, id: RowsField[input_id] } });
        }

        hanldeBlur(row.id, e);



    };
    const handleChange = (e) => {
        const { id, value } = e.target
        let isValid = true
        if ([RowsField.denier, RowsField.fedNo, RowsField.perMtrWeight, RowsField.wastagePer, RowsField.wastageWeight, RowsField.totalWeight, RowsField.totalPick, RowsField.ends].includes(id))
            isValid = funValidateNoInput(value)
        if (isValid)
            setLocalValue(value)

    }
    return (
        <Input
            isRequired={is_required}
            id={RowsField[input_id]}
            type={input_type}
            size="sm"
            labelPlacement="outside"
            readOnly={is_readonly}
            placeholder={holder_text}
            onKeyDown={(e) => handleKeyDown(row.id, e)}
            value={localValue}
            //onChange={(e) => setLocalValue(e.target.value)}
            onChange={handleChange}
            onBlur={onBlur}
            className="max-w-xs mt-1"
            variant={variant || "bordered"}
            color={color || ""}
        />
    );
};
const YarnOpenEntry = () => {
    const { compCode, appType, startDate } = useSelector((state) => state.company)
    //const { isNewEntry, mcsDetailParams } = useSelector((state) => state.monthExpEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gridContainerRef = useRef();
    const [searchText, setSearchText] = useState("")
    const [isNewEntry, setIsNewEntry] = useState(true)
    const [deleteOption, setDeleteOption] = useState(false)
    const [btnLabel, setBtnLabel] = useState("Add")
    const [selAsOndate, setSelAsOnDate] = useState(dayjs(startDate).format("YYYY-MM-DD"))

    const [selectedRowId, setSelectedRowId] = useState("")
    const [allRows, setAllRows] = useState([])
    const refItem = useRef();

    const { isPending: isPendingDel, mutate: funDelete } = usePost({
        url: apiRoute.yarnOpen.deleteEntry,
        queryKey: "DeleteYarnEntry",
        onSuccessTasks: (data) => {
            toast.success("Deleted Successfully...", {
                position: "top-center",
            })
            setRows([])
            setDeleteOption(false)
            setFormData({ ...initialRow })
        }
    })

    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.yarnOpen.fetchMasterData,
        queryKey: "getMasterData",
        inputData: {
            comp_code: compCode.join(",")
        }
    })






    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePostMutateWithSuccess({
        url: apiRoute.yarnOpen.fetchEntryDetail,
        queryKey: "fetchMasterItemDetail",
    });


    const [deletedItemRows, setDeletedItemRows] = useState([])

    const [rows, setRows] = useState([])

    const initialRow = {
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.pcs]: "",
        [RowsField.weight]: "",
        [RowsField.rate]: "",
        [RowsField.amount]: "",
    }


    // const emptyFormField = Object.keys(formField).reduce((acc, key) => {
    //     acc[key] = dayjs(startDate).format("YYYY-MM-DD")
    //     return acc
    // }, {})

    const [formData, setFormData] = useState({


        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.pcs]: "",
        [RowsField.weight]: "",
        [RowsField.rate]: "",
        [RowsField.amount]: "",
    })

    const inputBoxes = {

        Row2: [

            {
                id: RowsField.itemCode,
                name: RowsField.itemCode,
                placeholder: "Item Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData?.itemMaster || [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: false,
            },
            {
                id: RowsField.pcs,
                name: RowsField.pcs,
                placeholder: "Pcs",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.weight,
                name: RowsField.weight,
                placeholder: "Weight",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.rate,
                name: RowsField.rate,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.amount,
                name: RowsField.amount,
                placeholder: "Amount",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],


    }

    const funLoadData = () => {
        funGetDetail({
            data: {
                comp_code: compCode.join(","),
                as_ondate: dayjs(startDate).format("YYYY-MM-DD"),
            },
            onSuccess: (data) => {

                const itemData = data.map((ele, index) => {
                    return {
                        id: ++index,
                        [RowsField.itemCode]: ele?.Item_Code,
                        [RowsField.itemName]: ele?.Item_Desc,
                        [RowsField.pcs]: ele?.Pcs,
                        [RowsField.weight]: ele?.Weight,
                        [RowsField.rate]: ele?.Rate,
                        [RowsField.amount]: ele?.Amount,


                    }
                })
                setRows(itemData)
                setAllRows(itemData)
            }
        })
    }


    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.yarnOpen.add_update,
        queryKey: "funAddUpdateMCSMaster",
        onSuccessTasks: (data) => {
            toast.success(`Submitted Successfully ! `, {
                position: "top-center"
            })
            funLoadData();
        }
    })
    useEffect(() => {
        funLoadData()

    }, [])

    console.log(rows, "row")
    const debouncedUpdaterRef = useRef(null);



    const funGridSetting = (value, id, index) => {
        let rowId = RowsField.amount
        if (id == rowId) {
            let lastRow = rows.length
            if (index == lastRow) {
                funGenGridRows(1);
            }
        }
    }
    const searchInAllKeys = (data, searchText) => {
        if (!searchText) return data;

        const lowerSearch = searchText.toLowerCase();

        return data.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    };

    useEffect(() => {
        const searchData = searchInAllKeys(allRows, searchText)

        setRows(searchData)

    }, [searchText])



    const hanldeBlur = (rowid, e) => {
        const { value, id, name } = e.target


        if (isMobile) {
            //  setSelRowIndex(rowid)
            funGridSetting(value, id, rowid)
        }
    }




    const itemGridHeadClass = "bill-grid-style"

    const columns = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 60,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="flex gap-2 font-semibold">
                    {row.id}
                    <strong>

                        <FontAwesomeIcon
                            color="red"
                            className="cursor-pointer text-md"
                            onClick={() => handleDeleteRow(row.id)}
                            icon={faSquareXmark}

                        ></FontAwesomeIcon>
                    </strong>
                    <strong>

                        <FontAwesomeIcon
                            color="green"
                            className="cursor-pointer text-md"
                            onClick={() => handleEditRow(row.id)}
                            icon={faEdit}

                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },

        {
            field: RowsField.itemName,
            headerName: "Yarn Item",
            minWidth: 300,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            flex: 1,
            align: "left",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.itemName]
                    }
                </div>)

        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.pcs]
                    }
                </div>)

        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.weight]
                    }
                </div>)

        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.rate]
                    }
                </div>)
        },


        {
            field: RowsField.amount,
            headerName: "Amount",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.amount]
                    }
                </div>)

        },


    ]



    const handleChange = (e) => {
        const { name, value } = e.target
        if (funValidateNoInput(value)) {
            let amt = formData?.amount
            if ([RowsField.weight, RowsField.rate].includes(name)) {
                let wt = name == RowsField?.weight ? value : formData?.[RowsField.weight] || 0
                let rate = name == RowsField?.rate ? value : formData?.[RowsField.rate] || 0
                amt = (wt * rate).toFixed(2)
            }
            setFormData({ ...formData, [name]: value, [RowsField.amount]: amt })
        }
    }

    const handleAutoCompleteChange = (value, rowid, name) => {




        // const index = rows.findIndex((ele) => ele.id == rowid)
        if (name == RowsField.itemCode) {
            let ItemName = ""
            const tempdata = masterData?.itemMaster || []
            const itemData = tempdata.filter((ele) => ele.Item_Code == value)
            if (itemData && itemData.length > 0) {
                ItemName = itemData[0]?.Item_Desc
            }
            setFormData({
                ...formData,
                [name]: value,
                [RowsField.itemName]: ItemName
            })
        }
        else
            setFormData({
                ...formData,
                [name]: value,
            })

        // }

    }
    const funGenGridRows = (no_ofrows) => {


        let newRowsId = rows.length + 1
        const newRow = {
            id: newRowsId, ...initialRow
        }
        setRows([...rows, newRow])
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)
        setTimeout(() => {
            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id="${newRowsId}"] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);

    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (rows[i].itemCode == "" || rows[i].itemCode == null) {
                    if (!msg.includes("Yarn Item"))
                        msg = msg + "  Yarn Item ,";
                    no = 1
                }
                if (rows[i].amount == "" || rows[i].amount == "0") {
                    if (i != rows.length - 1) {
                        if (!msg.includes("Amount"))
                            msg = msg + " Amount ,";
                        no = 1
                    }

                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        if (formData[RowsField.itemCode].trim() === "" || formData[RowsField.itemCode] == null) {
            newErrors[RowsField.itemCode] = "Item Name is required"
        }
        // if (formData[RowsField.pcs] === "" || formData[RowsField.pcs] == null || formData[RowsField.pcs] == "0") {
        //     newErrors[RowsField.pcs] = "Pcs is required"
        // }
        if (formData[RowsField.weight] === "" || formData[RowsField.weight] == null || formData[RowsField.weight] == "0") {
            newErrors[RowsField.weight] = "Weight is required"
        }

        // if (formData[RowsField.rate] === "" || formData[RowsField.rate] == null || formData[RowsField.rate] == "0") {
        //     newErrors[RowsField.rate] = "Rate is required"
        // }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    // useEffect(() => {
    //     validateForm();
    // }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()
        

        // const grid_msg = ValidateGrid();

        // let rowData = rows;
        if (rows.length > 0) {
            //     let last_inx = rows.length - 1
            //     if (rows[last_inx].amount == "0" || rows[last_inx - 1].amount == "") {
            //         rowData = rows.slice(0, last_inx)
            //     }
            // }

            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    as_ondate: selAsOndate,
                    login_userid: user.username,
                    listItem: rows,
                    deleteItemList: deletedItemRows,
                    rec_status: !isNewEntry ? 1 : 2,
                }
            })

        }
        else {
            toast.error("Add Atleast One  Item", {
                "position": "top-center"
            })
        }

    }

    const handleEditRow = (id) => {
        const editRow = rows.filter((row) => row.id == id)


        setFormData(...editRow)
        setSelectedRowId(id)
        setBtnLabel("Edit")

    }

    const handleDeleteRow = (id) => {
        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        setRows(updatedRows)
        setAllRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }


    const handleAddRow = () => {
        const validate_form = validateForm()
        if (validate_form) {
            let isDuplicate = false
            const chkDup = rows.filter((ele) => ele.itemCode == formData.itemCode && ele?.id != formData.id)
            if (chkDup && chkDup.length > 0)
                isDuplicate = true

            if (!isDuplicate) {
                if (selectedRowId && selectedRowId != "") {
                    const currentDataIndex = rows.findIndex((ele) => ele.id == selectedRowId);
                    const updateData = { ...rows[currentDataIndex], ...formData }
                    const newData = [...rows]
                    newData[currentDataIndex] = updateData
                    setSelectedRowId("")
                    setRows(newData)
                    setBtnLabel("ADD")
                    setFormData({ ...initialRow })
                    setAllRows(newData)

                    // })

                }
                else {
                    // setIsFocus(true)
                    const newRow = { id: rows.length + 1, ...formData, }
                    setRows([...rows, newRow])
                    setAllRows([...allRows, newRow])
                    setFormData({ ...formData, ...initialRow })


                }
            }
            else {
                toast.error("Item Exist Duplicate Item Not Allow", {
                    position: "top-center"
                })
            }
            if (refItem.current) {
                refItem.current.focus(); // Clear file input
            }
        }
        else {
            // if (!toast.isActive('toats_chkreqrd')) {
            //     toast.error("Fill all required values", {
            //         "position": "top-center",
            //         "className": "toast-error",
            //         toastId: "toats_chkreqrd",
            //     })
            // }

        }
        // funGenGridRows(1)
    }



    const totalAmount = rows.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );

    const handleReset = () => {
        setFormData({ ...formData, ...initialRow })
        setBtnLabel("ADD")
    }
    const handleCancle = () => {
        window.location.reload()
    }
    const handleConfirmBox = (data) => {
        if (data) {

            funDelete({
                data: {
                    comp_code: compCode.join(","),
                    as_ondate: selAsOndate,
                }
            })
        }
        else {
            setDeleteOption(false)
        }

    }

    const handleDeleteEntry = () => {
        setDeleteOption(true)


    }

    if (isPending || isPendingDel) {
        return <LoadingCard />;
    }

    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            {deleteOption ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer
                pageName={`${isNewEntry ? "" : ""} Yarn Opening Stock Entry `}
                breadcrumbs={["Other Transaction", "Yarn Opening Stock Entry"]}
            // prevPage={{
            //     show: true,
            //     onClick: handleClickPrev,
            // }}
            >

                <div shadow="sm" className="mb-3 w-full">

                    <form onSubmit={handleSubmit} autoComplete='off'>


                        <div className=" w-full  items-center">
                            <h2 className="text-xs text-blue-700 uppercase mt-1 font-bold">As OnDate</h2>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                   // label={"As OnDate"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    readOnly={true}
                                    value={
                                        selAsOndate
                                            ? dayjs(selAsOndate)
                                            : selAsOndate
                                    }
                                    onChange={(newValue) => {
                                        setSelAsOnDate(
                                            dayjs(newValue).format("YYYY-MM-DD"),

                                        );
                                    }}
                                    //isRequired={item.required}
                                    className="w-full bg-red-100 font-semibold "
                                    slotProps={{
                                        textField: { size: "small", required: true, },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>





                        <div className="p-3 border-2  bg-j-50 mt-3">
                            <h2 className="text-blue-700 text-sm uppercase font-semibold mb-2"> <FontAwesomeIcon icon={faStar} ></FontAwesomeIcon> Add Stock</h2>
                            <div className="flex  items-center gap-5 flex-wrap sm:flex-nowrap md:flex-nowrap">

                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` flex-wrap sm:felx-nowrap md:flex-nowrap   flex gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    inputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <></>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <Autocomplete
                                                                size="sm"
                                                                ref={refItem}
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                menuTrigger="input"
                                                                variant="flat"
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoading}
                                                                className="w-full md:min-w-60 sm:min-w-60 text-xs  font-semibold"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                //isDisabled={item.name == formField.costMonth ? rows && rows.length > 0 ? false : true : false}
                                                                isReadOnly={selectedRowId && selectedRowId > 0 ? true : false}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, "", item.name, "")
                                                                }
                                                                color="danger"
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem
                                                                        classNames={{
                                                                            base: "",
                                                                            title: "text-xs ",
                                                                        }}
                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>


                                                        ) : (
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                //aria-label={item.placeholder}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                //disabled={mcsIsNewEntry ? false : true}
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => hanldeBlur("", e)}
                                                                isReadOnly={item.name == RowsField.amount ? true : false}
                                                                //  readOnly={item.name == formField.voucherNo ? true : false}
                                                                size={"sm"}
                                                                className=" w-full "
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>

                                        </div>

                                    ))
                                }

                                <div className="flex gap-3 items-center ">
                                    <Button size="sm" color="success" className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow"
                                        onPress={handleAddRow}>
                                        {btnLabel}
                                    </Button>
                                    <Button size="sm" color="warning" className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faXmark} />} variant="shadow"
                                        onPress={handleReset}>
                                        Reset
                                    </Button>
                                </div>

                            </div>
                        </div>
                        <div className="mt-5">
                            <div>

                                {rows.length <= 0 ? "" :
                                    <div className="my-2">
                                        <Input type="text" size="sm"
                                            radius="none" placeholder="Search ...."
                                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                                            variant="bordered" className="bg-white border-1 border-gray-300"
                                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                                    </div>}
                                {rows && rows?.length > 0 && <>
                                    {detail && detail.length > 0 ?
                                        <Button size="sm" color="danger" isLoading={isPendingDel} className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faTrashCan} />} variant="shadow"
                                            onPress={handleDeleteEntry}>
                                            Delete All Entry
                                        </Button> : ""}
                                    <Box ref={gridContainerRef} sx={{
                                        //overflow: "scroll",
                                        //height:   rows.length > 5 ? 300 : "auto",
                                        width: '100%',
                                    }}>
                                        {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                        <DataGrid
                                            // ref={gridContainerRef}
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            columnHeaderHeight={30}
                                            rowHeight={30}
                                            disableColumnSorting={true}
                                            disableColumnMenu={true}
                                            getRowClassName={(params) => {
                                                return 'row-class';
                                            }}
                                            sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                    },
                                                    '& .select-row': {
                                                        backgroundColor: "#ebe8e8"
                                                    },
                                                    '& .row-class': {
                                                        fontSize: "11px"
                                                    },
                                                    '& .sticky-row': {
                                                        position: 'sticky',
                                                        bottom: 0,
                                                        color: "#FFFFFF",
                                                        backgroundColor: '#424242f5',
                                                        zIndex: 10,
                                                    },
                                                    '& .sticky-row:hover': {
                                                        backgroundColor: "#424242f5"
                                                    }
                                                }}

                                        />
                                    </Box></>
                                }
                                <div className="justify-center flex gap-5 mt-5">
                                    <Button
                                        color="primary"
                                        type="submit"
                                        size="sm"
                                        variant="shadow"
                                        isLoading={isPending}
                                        isDisabled={isPending}
                                        startContent={<FontAwesomeIcon icon={faSave} />}
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        color="danger"
                                        variant="shadow"
                                        size="sm"
                                        onPress={handleCancle}
                                        startContent={<FontAwesomeIcon icon={faCancel} />}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </MainContainer>
        </div>
    )

}
export default YarnOpenEntry